import { Typography } from '@mui/material';
import { memo } from 'react';

import { catalogProductCellTextSx } from 'shared/ui/CatalogProductTable';

interface InventoryMinOnHandCellProps {
    minAllowedInStock?: number;
}

export const InventoryMinOnHandCell = memo(
    ({ minAllowedInStock = 0 }: InventoryMinOnHandCellProps) => {
        return (
            <Typography align="center" sx={catalogProductCellTextSx}>
                {minAllowedInStock || 0}
            </Typography>
        );
    },
);
